import { Checkbox as UiKitCheckbox } from '@cian/ui-kit/checkbox';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Checkbox.css';

interface ICheckboxProps extends React.ComponentPropsWithoutRef<typeof UiKitCheckbox> {
  className?: string;
  testId?: string;
}

export const Checkbox: React.FC<ICheckboxProps> = ({ className, testId, ...props }) => {
  return (
    <div className={classNames(styles['container'], className)} data-testid={testId}>
      <UiKitCheckbox {...props} />
    </div>
  );
};
